module.exports = __webpack_public_path__ + "img/banner_left.5a200443.jpg";